import React from "react";

const TooltipContent = (
    {
        active,
        payload,
        data,
        pageTranslations,
        clickedCellIndex,
        selectedCellIndex,
        TooltipContent,
        ModalContent, ...props
    }) => {

    if ( clickedCellIndex !== null || selectedCellIndex === clickedCellIndex) {
        return <ModalContent pageTranslations={pageTranslations} data={data} />
    }
    else if (selectedCellIndex !== null && selectedCellIndex !==clickedCellIndex) {
        return <TooltipContent
            active={active}
            payload={payload}
        />;
    }
    return <TooltipContent/>;
};

export default TooltipContent